import { render, staticRenderFns } from "./BanksTable.vue?vue&type=template&id=1dda9d43&"
import script from "./BanksTable.vue?vue&type=script&lang=js&"
export * from "./BanksTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports